var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.207 10.952c-1.005 0-1.819.854-1.819 1.905v6.667H6.843s.054-11.429 0-12.381h4.545v1.414s1.408-1.374 3.581-1.374c2.692 0 4.601 2.04 4.601 6.004v6.337h-4.545v-6.667c0-1.051-.814-1.905-1.818-1.905zM2.743 5.238h-.026C1.343 5.238.455 4.112.455 2.875.455 1.61 1.37.578 2.77.578c1.401 0 2.262 1.065 2.29 2.33 0 1.239-.889 2.33-2.317 2.33zm2.282 14.286H.479V7.143h4.546v12.38z"}));
}

Linkedin.defaultProps = {"width":"20","height":"20"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
